import type { atlascloudModelConfig, StatusMapping } from './types';
import { googleConfigs } from './configs/google';
import { blackForestLabsConfigs } from './configs/black-forest-labs';

/**
 * atlascloud 状态映射配置（所有模型统一使用）
 */
export const atlascloudStatusMapping: StatusMapping = {
    /** 任务 ID 字段路径 */
    taskIdPath: 'data.id',
    /** 状态字段路径 */
    statePath: 'data.status',
    /** 成功状态值 */
    success: ['completed', 'succeeded'],
    /** 失败状态值 */
    failed: ['failed', 'timeout'],
    /** 处理中状态值 */
    processing: ['created', 'processing'],
    /** 视频 URL 字段路径 */
    videoUrlPath: 'data.outputs[0]',
    /** 错误信息字段路径 */
    errorPath: 'data.error',
};

/**
 * 模型配置映射
 */
export const atlascloudModelConfigs: Record<string, atlascloudModelConfig> = {
    ...googleConfigs,
    ...blackForestLabsConfigs,
};